import React, { useState } from "react";
import { Modal, Button, Table, Space, message } from "antd";
import { useGlobal } from "../global/user";
import MessageGroupModal from "./modal/MessageGroupModal";
import axios from "axios";
import MailTokenModal from "./modal/MailTokenModal";

const backendServer = process.env.REACT_APP_BACKEND;

export default function ImageTableNew() {
  const { fields, user } = useGlobal();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMailTokenModalOpen, setIsMailTokenModalOpen] = useState(false);

  const columns = [
    {
      title: "場域名稱",
      dataIndex: "field_name",
      filterSearch: true,
      onFilter: (value, record) => new RegExp(value, "i").test(record.field_name),
      filters: [...new Set(fields.map((m) => m.field_name))].map((field_name) => ({
        text: field_name,
        value: field_name,
      })),
    },
    {
      title: "機具數目",
      dataIndex: "count",
    },
    {
      title: "日報群組",
      dataIndex: "ReportGroup",
    },
    {
      title: "警報群組",
      dataIndex: "WarningGroup",
    },
    {
      title: "伺服器群組",
      dataIndex: "ServerGroup",
    },
    {
      title: "創建時間",
      dataIndex: "create_time",
    },
    {
      title: "主管",
      dataIndex: "name",
    },
  ];

  return (
    <React.Fragment>
      <Space style={{ display: "flex", justifyContent: "flex-start" }} className="mb-2">
        <Button onClick={() => setIsModalOpen(true)} hidden={user.class < process.env.REACT_APP_MANAGER_CALSS_LV}>
          管理訊息群組
        </Button>
        <Button
          onClick={() => {
            setIsMailTokenModalOpen(true);
          }}
          hidden={user.class < process.env.REACT_APP_MANAGER_CALSS_LV}
        >
          管理通知郵件
        </Button>
        <Button
          onClick={() => {
            Modal.confirm({
              title: "確認",
              content: "確認重啟服務",
              okText: "確認",
              cancelText: "取消",
              onOk: () => {
                axios
                  .get(`${backendServer}mail2line/restart`)
                  .then(() => {
                    message.success("重啟成功");
                  })
                  .catch(() => message.error("重啟失敗"));
              },
            });
          }}
        >
          重啟圖片轉發服務(新版)
        </Button>
        <Button
          onClick={() => {
            Modal.confirm({
              title: "確認",
              content: "確認重啟服務",
              okText: "確認",
              cancelText: "取消",
              onOk: () => {
                axios
                  .get(`${backendServer}mailer/restart`)
                  .then(() => {
                    message.success("重啟成功");
                  })
                  .catch(() => message.error("重啟失敗"));
              },
            });
          }}
        >
          重啟圖片轉發服務(舊版)
        </Button>
      </Space>
      <Table
        columns={columns}
        dataSource={fields}
        rowKey="field_id"
        pagination={{
          defaultPageSize: 10,
          showTotal: (total) => `共 ${total} 筆資料`,
          showSizeChanger: false,
        }}
        bordered
      />
      <MessageGroupModal open={isModalOpen} onCancel={() => setIsModalOpen(false)} />
      <MailTokenModal open={isMailTokenModalOpen} onCancel={() => setIsMailTokenModalOpen(false)} />
    </React.Fragment>
  );
}
